var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade-up"}},[(_vm.parsedErrors.length > 0)?_c('div',{staticClass:"error",class:{ 'error--center': _vm.center }},[_c('p',{staticClass:"error__content",domProps:{"innerHTML":_vm._s(_vm.errors)}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }